import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { RedbookVehiclePhoto } from "../../types/Vehicles";

export const getVehicleImages = (
  variantCode: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["vehicle-images", variantCode],
    queryFn: (): Promise<RedbookVehiclePhoto[]> => {
      return fetchWithAuth<RedbookVehiclePhoto[]>(
        "getVehicleImages",
        variantCode
      );
    },
    enabled: isQueryEnabled(options),
  });
};
